import Container from "@components/Container";
import { OptionCard, Title } from "@justhome/react-ui";
import { ApplicationTypeEnum } from "@lib/api/enums";
import { ComponentSectionsBudgetFormNavigator } from "@lib/generated/graphql";
import { useApplicationTranslation } from "@lib/hooks/translations";
import { OTHER } from "@modules/application/lib/applicationProcess/types";
import clsx from "clsx";
import { useRouter } from "@lib/hooks/useRouter";
import { FC } from "react";

export interface BudgetFormNavigatorProps {
  isArticleLayout?: boolean;
  data: ComponentSectionsBudgetFormNavigator;
}

const BudgetFormNavigator: FC<BudgetFormNavigatorProps> = ({
  isArticleLayout = false,
  data,
}) => {
  const router = useRouter();
  const { t } = useApplicationTranslation();
  const { title } = data;

  const fieldDefinition = [
    {
      value: ApplicationTypeEnum.BUY_WITH_SAVINGS,
      label: t(
        isArticleLayout
          ? "article_compare_buy_with_savings"
          : "compare_buy_with_savings",
      ),

      image: "/assets/img/house.svg",
      columns: 4,
      href: "/vergleich/immobilie-kaufen",
    },
    {
      value: ApplicationTypeEnum.BUILD_HOUSE,
      label: t(
        isArticleLayout
          ? "article_compare_build_a_house"
          : "compare_build_a_house",
      ),

      image: "/assets/img/build-a-house.svg",
      columns: 4,
      href: "/vergleich/haus-bauen",
    },
    {
      value: ApplicationTypeEnum.REFINANCING,
      label: t(
        isArticleLayout ? "article_compare_refinancing" : "compare_refinancing",
      ),
      image: "/assets/img/refinance.svg",
      columns: 4,
      href: "/vergleich/anschlussfinanzieren",
    },
    {
      value: OTHER,
      href: "/vergleich/other",
      label: t("compare_other"),
      columns: 12,
    },
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <Container
        padding
        className={clsx(
          isArticleLayout
            ? "flex"
            : "grow grid place-content-center grid-cols-12",
        )}
      >
        <div className="w-full col-span-12 m:col-span-8 m:col-start-3 my-m">
          <Title className="text-d3 mb-3s m:mb-3m">{title || ""}</Title>
          <div className="grid grid-cols-12 gap-2s">
            {fieldDefinition.map((option, index) => (
              <OptionCard
                className={clsx("col-span-10 col-start-2 m:col-start-auto", {
                  "m:col-span-4": option.columns === 4,
                  "m:col-span-12": option.columns === 12,
                  "m:col-span-6": !option.columns,
                })}
                image={option.image}
                key={index}
                value={option.value}
                onClick={(e) => {
                  e.preventDefault();
                  router.push(option.href);
                }}
              >
                <span className="whitespace-pre-wrap">{option.label}</span>
              </OptionCard>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default BudgetFormNavigator;
